module.exports = __webpack_public_path__ + "static/media/specsNewBackground.60f29018.png";